module.exports = __webpack_public_path__ + "img/PUREHEALS1.87e71d9d.jpg";